import axios from 'axios';
import { getAuthToken } from '../utils/sessionAuth.js';

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/night-rest`;

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const jsonHeaders = () => ({ ...authHeaders(), 'Content-Type': 'application/json' });

const listPolicies = async () => {
  const response = await axios.get(API_URL, { headers: authHeaders() });
  return response.data?.policies || [];
};

const listDevices = async () => {
  const response = await axios.get(`${API_URL}/devices`, { headers: authHeaders() });
  return response.data?.devices || [];
};

const getPolicy = async (id) => {
  const response = await axios.get(`${API_URL}/${encodeURIComponent(id)}`, { headers: authHeaders() });
  return response.data?.policy;
};

const createPolicy = async (payload) => {
  const response = await axios.post(API_URL, payload, { headers: jsonHeaders() });
  return response.data?.policy;
};

const updatePolicy = async (id, payload) => {
  const response = await axios.put(`${API_URL}/${encodeURIComponent(id)}`, payload, { headers: jsonHeaders() });
  return response.data?.policy;
};

const deletePolicy = async (id) => {
  const response = await axios.delete(`${API_URL}/${encodeURIComponent(id)}`, { headers: authHeaders() });
  return response.data;
};

const syncAll = async () => {
  const response = await axios.post(`${API_URL}/sync`, {}, { headers: jsonHeaders() });
  return response.data;
};

const syncPolicy = async (id) => {
  const response = await axios.post(`${API_URL}/${encodeURIComponent(id)}/sync`, {}, { headers: jsonHeaders() });
  return response.data?.policy;
};

const setOverride = async (id, mode) => {
  const response = await axios.post(
    `${API_URL}/${encodeURIComponent(id)}/override`,
    { mode },
    { headers: jsonHeaders() }
  );
  return response.data?.policy;
};

const getDeviceState = async (udid) => {
  const response = await axios.get(
    `${API_URL}/device/${encodeURIComponent(udid)}`,
    { headers: authHeaders() }
  );
  return response.data;
};

const setDeviceOverride = async (udid, payload) => {
  const response = await axios.put(
    `${API_URL}/device/${encodeURIComponent(udid)}/override`,
    payload,
    { headers: jsonHeaders() }
  );
  return response.data;
};

const nightRestService = {
  listPolicies,
  listDevices,
  getPolicy,
  createPolicy,
  updatePolicy,
  deletePolicy,
  syncAll,
  syncPolicy,
  setOverride,
  getDeviceState,
  setDeviceOverride,
};

export default nightRestService;
